import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=81482f92&scoped=true&"
import script from "./AlertBanner.vue?vue&type=script&lang=js&"
export * from "./AlertBanner.vue?vue&type=script&lang=js&"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=81482f92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81482f92",
  null
  
)

export default component.exports